module.exports = __webpack_public_path__ + "img/IMG_1518.5dae5c10.jpg";